export default function Home() {
  return (
    <div className="flex flex-col min-h-screen">
      <main>
        <HeroSection />
        <StatsSection />
        <FeaturesSection />
        <ServicesSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>

      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'btbxx',
        url: 'https://www.btbxx.com/',
        description: 'btbxx是您值得信赖的专业平台，提供全方位优质服务。企业解决方案、技术平台、营销增长、数据智能一站式服务。',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://www.btbxx.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      })}</script>

      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'btbxx',
        url: 'https://www.btbxx.com/',
        description: '值得信赖的全方位专业企业服务平台',
        foundingDate: '2020',
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+86-400-888-8888',
          contactType: 'customer service',
          availableLanguage: ['Chinese'],
        },
      })}</script>

      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'btbxx官方首页',
        description: 'btbxx是您值得信赖的专业平台，提供全方位优质服务。了解btbxx的核心功能、服务优势与用户评价。',
        url: 'https://www.btbxx.com/',
        isPartOf: { '@type': 'WebSite', name: 'btbxx', url: 'https://www.btbxx.com/' },
      })}</script>
    </div>
  );
}

function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20minimalist%20geometric%20composition%20with%20soft%20cream%20and%20terracotta%20gradients%2C%20flowing%20organic%20shapes%2C%20modern%20corporate%20backdrop%2C%20elegant%20subtle%20texture%2C%20high%20end%20professional%20atmosphere%2C%20clean%20spacious%20design&width=1800&height=1200&seq=btbxx-hero-bg&orientation=landscape"
          alt="btbxx平台 - 全方位专业企业服务平台"
          title="btbxx 企业服务平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/45 via-foreground-950/30 to-foreground-950/55"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20 md:py-28">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6 md:mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-xs md:text-sm font-label text-background-100 tracking-wide">全新 3.0 版本正式上线</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6 md:mb-8">
          值得信赖的
          <br />
          <span className="text-primary-400">全方位专业服务平台</span>
        </h1>

        <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-10 md:mb-12 leading-relaxed font-body">
          btbxx 为企业提供从技术架构到业务增长的全链路解决方案。覆盖企业解决方案、技术平台、营销增长、数据智能等核心领域，助力您的业务实现跨越式增长。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#cta"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-label font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105 transform"
          >
            立即免费体验
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href="#features"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-background-50/15 backdrop-blur-sm text-background-100 font-label font-medium text-sm md:text-base hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer border border-background-50/20"
          >
            了解更多
            <i className="ri-arrow-down-line ml-2"></i>
          </a>
        </div>

        <div className="mt-14 md:mt-16 flex flex-wrap items-center justify-center gap-8 md:gap-12">
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">10,000+</p>
            <p className="text-xs md:text-sm text-background-300 mt-1 font-label">服务企业</p>
          </div>
          <div className="w-px h-10 bg-background-50/20 hidden sm:block"></div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">99.9%</p>
            <p className="text-xs md:text-sm text-background-300 mt-1 font-label">系统稳定性</p>
          </div>
          <div className="w-px h-10 bg-background-50/20 hidden sm:block"></div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">95%</p>
            <p className="text-xs md:text-sm text-background-300 mt-1 font-label">客户满意度</p>
          </div>
        </div>
      </div>
    </section>
  );
}

function StatsSection() {
  const stats = [
    { number: '10,000+', label: '服务企业客户', icon: 'ri-building-line' },
    { number: '50+', label: '行业解决方案', icon: 'ri-stack-line' },
    { number: '200+', label: '技术团队成员', icon: 'ri-team-line' },
    { number: '99.99%', label: '服务可用率', icon: 'ri-shield-check-line' },
  ];

  return (
    <section className="relative -mt-16 z-10">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-background-50 rounded-lg p-5 md:p-7 text-center border border-background-200/60"
            >
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-lg bg-primary-100">
                <i className={`${stat.icon} text-primary-600 text-lg`}></i>
              </div>
              <p className="font-heading text-xl md:text-2xl font-bold text-foreground-950">{stat.number}</p>
              <p className="text-xs md:text-sm text-foreground-600 mt-1 font-label">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function FeaturesSection() {
  const features = [
    {
      icon: 'ri-server-line',
      title: '云原生架构',
      desc: '基于容器化和微服务的云原生技术架构，弹性伸缩、高可用，支撑海量业务并发处理。',
    },
    {
      icon: 'ri-brain-line',
      title: 'AI智能引擎',
      desc: '深度融合机器学习和深度学习技术，智能分析数据、预测趋势、自动优化业务流程。',
    },
    {
      icon: 'ri-shield-keyhole-line',
      title: '安全防护体系',
      desc: '多层安全防护机制，数据传输加密存储加密，全面保障企业数据安全和合规性。',
    },
    {
      icon: 'ri-bar-chart-grouped-line',
      title: '数据分析平台',
      desc: '实时数据可视化和智能分析，拖拽式图表配置，让数据驱动每一个商业决策。',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '专属客户服务',
      desc: '7x24小时在线支持，专属客户成功经理全程跟进，快速响应每一个服务需求。',
    },
    {
      icon: 'ri-plug-line',
      title: '开放API集成',
      desc: '标准化API接口，丰富预置集成方案，无缝对接现有ERP、CRM等企业系统。',
    },
  ];

  return (
    <section id="features" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-label font-medium tracking-wide mb-4">
            核心功能
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            btbxx 为您提供全方位
            <br className="hidden md:block" />
            企业数字化能力
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto font-body">
            六大核心功能模块覆盖企业运营全链路，从基础设施到业务增长，一站满足
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/60 hover:border-primary-200/60 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-5 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed font-body">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function ServicesSection() {
  const services = [
    {
      icon: 'ri-building-2-line',
      title: '企业解决方案',
      desc: '端到端的数字化解决方案，覆盖企业管理、流程优化、数据分析等核心领域，帮助企业实现全面数字化转型。',
      features: ['智能办公系统', '流程自动化', '项目管理工具', '数据分析引擎'],
    },
    {
      icon: 'ri-cloud-line',
      title: '技术平台',
      desc: '基于云原生架构的高可用技术基础设施，支撑海量业务并发，保障系统稳定高效运行。',
      features: ['云原生架构', 'API集成中心', '安全防护体系', '智能监控告警'],
    },
    {
      icon: 'ri-line-chart-line',
      title: '营销增长',
      desc: '全渠道数字营销解决方案，从智能投放到内容矩阵，助力企业实现用户规模和营收快速增长。',
      features: ['智能投放系统', '内容营销矩阵', '用户画像分析', '转化漏斗优化'],
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-label font-medium tracking-wide mb-4">
            服务领域
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            覆盖企业核心业务场景
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto font-body">
            从技术基础设施到业务增长引擎，btbxx一站式满足企业多样化需求
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8">
          {services.map((service) => (
            <div
              key={service.title}
              className="group bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/60 hover:border-accent-200/60 transition-all duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${service.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-3">
                {service.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5 font-body">
                {service.desc}
              </p>
              <ul className="space-y-2">
                {service.features.map((f) => (
                  <li key={f} className="flex items-center gap-2 text-sm text-foreground-700 font-label">
                    <i className="ri-check-line text-accent-600 text-sm"></i>
                    {f}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="/categories"
            className="inline-flex items-center gap-2 text-sm font-label font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 cursor-pointer"
          >
            查看全部服务分类
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}

function TestimonialsSection() {
  const testimonialsList = [
    {
      name: '张明远',
      role: 'CEO',
      company: '远航科技集团',
      content: '使用btbxx平台后，我们的运营效率提升了200%。从数据分析到客户管理，btbxx的一站式服务让团队协作更加流畅，是我们数字化转型的最佳伙伴。',
      rating: 5,
    },
    {
      name: '李婷',
      role: '运营总监',
      company: '星辰电商有限公司',
      content: 'btbxx的智能营销工具帮我们在三个月内将获客成本降低了45%，同时销售额增长了80%。数据驱动的营销策略让每一分钱都花在刀刃上。',
      rating: 5,
    },
    {
      name: '王建华',
      role: 'CTO',
      company: '建业制造集团',
      content: '作为技术负责人，我最看重的是btbxx的技术架构和扩展性。云原生架构让系统稳定性有了质的飞跃，API集成能力也让我们的技术栈更加灵活。',
      rating: 5,
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-label font-medium tracking-wide mb-4">
            用户评价
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            客户眼中的 btbxx
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto font-body">
            超过10,000家企业选择了btbxx，听听他们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8">
          {testimonialsList.map((item) => (
            <div
              key={item.name}
              className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/60"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: item.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-6 font-body">
                "{item.content}"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-primary-700 font-label font-semibold text-sm">
                    {item.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-label font-semibold text-foreground-950">{item.name}</p>
                  <p className="text-xs text-foreground-500 font-label">{item.role} · {item.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function FAQSection() {
  const faqs = [
    {
      question: 'btbxx平台适合什么类型的企业使用？',
      answer: 'btbxx平台面向各类规模的企业提供服务，无论您是初创公司、中小型企业还是大型集团，都能在btbxx找到适合的解决方案。我们的模块化设计允许企业根据自身需求灵活选择功能组合。',
    },
    {
      question: 'btbxx平台的部署周期是多长？',
      answer: 'btbxx平台标准版的部署周期通常为1-2周。对于有定制化需求的企业客户，部署周期会根据具体需求调整，一般在4-6周内完成。我们的实施团队会全程跟进，确保按时交付。',
    },
    {
      question: 'btbxx平台的数据安全如何保障？',
      answer: 'btbxx采用多重安全防护机制，包括数据传输加密（TLS 1.3）、存储加密（AES-256）、访问控制（RBAC）、操作审计、DDoS防护等。我们定期进行安全审计和渗透测试，确保客户数据的安全性。',
    },
    {
      question: 'btbxx平台是否支持与现有系统集成？',
      answer: '是的，btbxx平台提供标准化的API接口和丰富的预置集成方案，支持与企业现有的ERP、CRM、财务系统、OA系统等无缝对接。我们的技术团队也可以根据客户需求开发定制化集成方案。',
    },
    {
      question: 'btbxx的收费模式是怎样的？',
      answer: 'btbxx采用灵活的模块化定价策略，企业可以根据实际需求选择功能模块，按需付费。我们提供免费试用期，让您在充分体验后再做决策。具体价格方案请联系我们的销售团队获取。',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-label font-medium tracking-wide mb-4">
            常见问题
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            关于 btbxx 的常见问题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base font-body">
            快速了解btbxx平台的核心信息
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <details key={index} className="group bg-background-50 rounded-lg border border-background-200/60 overflow-hidden">
              <summary className="flex items-center justify-between px-5 md:px-7 py-5 cursor-pointer list-none [&::-webkit-details-marker]:hidden">
                <span className="text-sm md:text-base font-label font-medium text-foreground-900 pr-6">
                  {faq.question}
                </span>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 group-open:bg-primary-100 group-open:text-primary-600 transition-all duration-200">
                  <i className="ri-add-line text-sm group-open:hidden"></i>
                  <i className="ri-subtract-line text-sm hidden group-open:block"></i>
                </span>
              </summary>
              <div className="px-5 md:px-7 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed font-body">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>

        <script type="application/ld+json">{JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqs.map((faq) => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.answer,
            },
          })),
        })}</script>
      </div>
    </section>
  );
}

function CTASection() {
  return (
    <section id="cta" className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20flowing%20gradients%20in%20terracotta%20and%20cream%20tones%2C%20soft%20geometric%20shapes%2C%20modern%20corporate%20backdrop%2C%20elegant%20clean%20design%2C%20minimalist%20professional%20background%2C%20subtle%20texture%20with%20organic%20flowing%20forms&width=1800&height=800&seq=btbxx-cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-foreground-950/70"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-4">
          准备好开启数字化之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-background-200/90 mb-10 max-w-xl mx-auto font-body leading-relaxed">
          立即注册btbxx，免费体验全方位企业数字化解决方案。超过10,000家企业已经选择了btbxx，下一个成功的就是你。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-label font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105 transform"
          >
            免费注册体验
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href="/about"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-background-50/10 backdrop-blur-sm text-background-100 font-label font-medium text-sm md:text-base hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap cursor-pointer border border-background-50/15"
          >
            预约产品演示
            <i className="ri-calendar-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}